"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userHasPermission = void 0;
const userHasPermission = (user, permission) => {
    const isVerbalOnlyPerm = /^Verbal/.test(permission) || /^Story/.test(permission);
    return !!user?.Role?.RolePermissions?.find((rolePermission) => ((isVerbalOnlyPerm && user?.isVerbal) || !isVerbalOnlyPerm) &&
        (rolePermission.permission === permission || rolePermission.permission === "FullAccess"));
};
exports.userHasPermission = userHasPermission;
